<template>
    <div class="dashboard">
        <layout>
            <md-app-content>
                <md-content>
                    <md-progress-spinner v-if="!loaded" :md-stroke="4" md-mode="indeterminate" class="dashboard__spinner"></md-progress-spinner>
                    <orders-history v-if="loaded"></orders-history>
                </md-content>
            </md-app-content>
        </layout>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters, mapActions} from 'vuex'
    import OrdersHistory from '../components/OrdersHistory'
    import Layout from '../components/Layout'

    export default {
        name: 'home',
        components: {
            OrdersHistory,
            Layout
        },
        data() {
            return {
                alert: false
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('dashboard', [
                'loaded',
                'location',
            ]),
        },
        methods: {
            ...mapActions('dashboard', [ 'loadLocation'])
        },
        mounted() {
            setInterval(function () {
                this.loadLocation(this.user.locationId)
            }.bind(this), 30000)

            this.loadLocation(this.user.locationId)
        }
    }
</script>
